var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBank07(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1378BE;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.4,55.2c0,3,0.1,6,0,9c0,1.1-0.3,3.1-0.8,3.2c-1.8,0.3-3.7,0.2-5.6,0c-0.3,0-0.7-1.2-0.7-1.8 c-0.1-7.4,0-14.7,0-22.1c0-1.6,0.8-2.3,2.4-2.3c0.7,0,1.4,0,2.1,0c5.5,0.1,4.4-1,6.6,5c1.2,3.4,2.3,6.8,3.9,10.3 c0.8-2.5,1.6-4.9,2.4-7.4c0.6-2,1.2-3.9,1.8-5.9c0.4-1.2,1.2-2,2.6-2c1.8,0.1,3.5,0,5.3,0c1.4,0,2.1,0.6,2.1,2c0,7.5,0,15,0,22.5 c0,1.4-0.7,2-2.1,2c-4.8,0.3-4.8,0.3-4.8-4.5c0-3.3,0-6.5,0-10.1c-1.4,4.1-2.8,7.9-4,11.8c-0.6,1.9-1.4,3-3.7,2.9 c-2.2,0-3.2-0.8-3.7-2.8c-0.9-3.3-2.1-6.6-3.2-9.8C42.8,55.2,42.6,55.2,42.4,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.1,54.5c0-3.5,0-7.1,0-10.6c0-1.9,0.6-2.7,2.6-2.7c3.8,0.1,7.5,0,11.3,0.1c5.9,0.1,8.9,5.5,5.9,10.6 c-0.6,1-0.9,1.6,0.1,2.5c2.6,2.3,2.5,5.4,1.6,8.3c-0.9,3-3.5,4.8-6.6,5c-4.3,0.3-8.6,0.1-13,0.1c-1.7,0-2-1.1-2-2.4 C67.1,61.7,67.1,58.1,67.1,54.5z M77.8,62c0.6,0,1.3,0,1.9,0c1.5,0,2.4-0.7,2.6-2.2c0.2-1.6-0.5-2.6-2-3c-1-0.2-2.1-0.3-3.1-0.3 c-2.8,0-2.9,0.1-2.9,2.8C74.3,62.1,74.3,62.1,77.8,62z M76.9,46.9c0-0.1-0.1-0.2-0.1-0.4c-1,0.4-2.6,0.5-3,1.2 c-1.2,2.3,0,3.9,2.7,3.9c0.4,0,0.9,0.1,1.3,0c1.6-0.3,3.6-0.4,3.6-2.4c0-2-1.8-2.4-3.6-2.3C77.5,46.9,77.2,46.9,76.9,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.9,41.2c2.9,0,5.8,0.1,8.7,0c2.3-0.1,2.4,1.5,2.4,3.1c0.1,1.6-0.2,3-2.3,3c-0.2,0-0.4,0-0.6,0 c-5.1,0.1-4.6-0.7-4.6,4.7c0,4.5,0,8.9,0,13.4c0,1.7-0.6,2.4-2.4,2.4c-4.9,0.1-4.9,0.2-4.9-4.8c0-4.5-0.1-8.9,0-13.4 c0-1.8-0.6-2.5-2.4-2.3c-0.6,0.1-1.3,0-1.9,0c-2.8,0-3.1-0.3-3.1-3c0-2.9,0.2-3.1,3.2-3.1C16.7,41.2,19.3,41.2,21.9,41.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40,30.1c2.7,0,4.6,1.9,4.6,4.5c0,2.7-1.9,4.5-4.8,4.4c-2.6,0-4.7-2.1-4.6-4.5C35.2,32.2,37.6,30.1,40,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,30.1c2.5,0.1,4.6,2.3,4.5,4.7c-0.1,2.5-2.2,4.3-4.9,4.2c-2.8-0.1-4.6-1.8-4.5-4.5 C55.2,31.8,57.2,30,60,30.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank07);
export default __webpack_public_path__ + "static/media/icon-bank-07.cf14d1a9bb63b8593093f29247223021.svg";
export { ForwardRef as ReactComponent };